import { render, staticRenderFns } from "./TalentMatrixView.vue?vue&type=template&id=ef5250a2&scoped=true"
import script from "./TalentMatrixView.vue?vue&type=script&lang=js"
export * from "./TalentMatrixView.vue?vue&type=script&lang=js"
import style0 from "./TalentMatrixView.vue?vue&type=style&index=0&id=ef5250a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5250a2",
  null
  
)

export default component.exports